/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />
/// <reference path="Confirm.js" />
/// <reference path="ProgressIndicator.js" />

class FeedStatusMessage extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.commentBox = this.el.querySelector(".newComment");
		this.textbox = this.el.querySelector(".newComment").querySelector("textarea");
		this.showCommentBoxLink = this.el.closest(".mia-FeedEntry").querySelector("div.mia-timespan a");
		this.safeObserve(this.el.querySelector(".newComment .mia-createMessage-submit"), 'click', this.onSubmitClick.bind(this));
		this.safeObserve(this.showCommentBoxLink, 'click', this.onCommentClick.bind(this));
		this.loadMoreComments = this.el.querySelector(".loadMoreComments");
		this.progressIndicator = new ProgressIndicator(this.el);

		// Initialize vue instance for smiley selector so vue component is parsed to html.
		// That is needed because comments are loaded asynchronously in the ajax call (vue initialized globally before that).
		const app = window.createVueApplication('legacy-smiley-selector');
		app.mount(this.el.querySelector(".mia-smileySelectorWrapper"));

		if (this.loadMoreComments != undefined)
			this.safeObserve(this.loadMoreComments, 'click', this.loadMore.bind(this));

		var comments = this.el.getElementsByClassName("feedComment");

		if (comments.length == 0) {
			this.el.style.display = 'none';
		} else {
			this.showCommentBoxLink.style.display = 'none';
		}
	}

	onCommentClick(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		this.showCommentBoxLink.style.display = 'none';
		this.el.style.display = this.el.style.display === 'none' ? '' : 'none';
	}

	onSubmitClick(ev) {
		ev.preventDefault();
		ev.stopPropagation();

		var text = this.textbox.value;

		if (text.trim() == "") {
			confirmAI(this.options.errorEmptyText, function() {}, function() {}, true, false);
			return;
		} else if (text.length > this.options.maxLength) {
			confirmAI(this.options.errorTooLongText, function() {}, function() {}, true, false);
			return;
		}

		this.progressIndicator.showProgressIndicator();
		axios(
			new UrlTemplate(this.options.addUrl).r("PLH_text", this.textbox.value).url,
			{
				method: 'get'
			}
		).then(this.onLoaded.bind(this));
	}

	onLoadException(ex) {
		console.log(ex.message);
		this.progressIndicator.hideProgressIndicator();
	}

	onLoaded(res) {
		this.progressIndicator.hideProgressIndicator();

		var json = res.data;

		if (json.success) {
			if (json.hideLastComment) {
				var commentContainer = this.commentBox.previousElementSibling;
				if (commentContainer) {
					var lastComment = jQuery(commentContainer).find('.feedComment').last();
					if (lastComment) {
						lastComment.hide();
					}
				}
			}
			var newComment = document.createElement("div");
			this.commentBox.parentNode.insertBefore(newComment, this.commentBox);
			jQuery(newComment).html(json.comment);
			this.textbox.value = "";
		} else {
			confirmAI(json.errorMessage, function() {}, function() {}, true, false);
		}
	}

	loadMore(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		var req = axios(this.options.feedCommentsUrl, {
			method: 'get'
		}).then(this.onResponse.bind(this));
	}

	onResponse(req) {
		var json;
		try {
			json = req.data;
		} catch (e) {
			this.write(e);
		}
		// insert after loadMore
		var div = document.createElement("div");
		div.innerHTML = json.comments;
		this.el.insertBefore(div, this.el.firstChild.nextSibling);

		// set new loadMoreURL
		this.options.feedCommentsUrl = json.feedCommentsUrl;

		// disable loadMore, if there are not more comments
		if (!json.moreComments) {
			this.loadMoreComments.style.display = 'none';
		} else {
			this.el.firstChild.innerHTML = json.moreCommentsString;
		}

		var scripts = div.getElementsByTagName('script');

		for (var ix = 0; ix < scripts.length; ix++) {
			eval(scripts[ix].text);
		}
	}
}
